// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4j-1";
export var standaloneTable = "_4j-0";